/** The `?` cheat sheet (PLAN.md §5.10) — shortcuts are useless if nobody can discover them. */

import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

const SHORTCUTS: { keys: string; description: string }[] = [
  { keys: 'Ctrl / ⌘ + K', description: 'Open the command palette' },
  { keys: '?', description: 'Show this sheet' },
  { keys: 'G then T', description: 'Go to tickets' },
  { keys: 'G then C', description: 'Go to companies' },
  { keys: 'N', description: 'New ticket' },
  { keys: 'Ctrl / ⌘ + Enter', description: 'Post the note you are writing' },
  { keys: 'Esc', description: 'Close a dialog' },
];

export function ShortcutSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-50">
        <Transition.Child
          as={Fragment}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-surface-900/40" aria-hidden="true" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="transition duration-200 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="transition duration-150 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md rounded-xl bg-white p-6 shadow-modal dark:bg-surface-800">
              <Dialog.Title className="mb-4 text-lg font-semibold text-surface-900 dark:text-surface-100">
                Keyboard shortcuts
              </Dialog.Title>
              <dl className="space-y-2">
                {SHORTCUTS.map((shortcut) => (
                  <div key={shortcut.keys} className="flex items-center justify-between gap-4 text-sm">
                    <dt className="text-surface-600 dark:text-surface-300">{shortcut.description}</dt>
                    <dd>
                      <kbd className="rounded border border-surface-300 bg-surface-100 px-2 py-0.5 font-mono text-xs text-surface-700 dark:border-surface-600 dark:bg-surface-900 dark:text-surface-200">
                        {shortcut.keys}
                      </kbd>
                    </dd>
                  </div>
                ))}
              </dl>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
